<template>
  <div
    v-if="parsedSvg"
    class="stroke-current stroke-1"
    :class="[iconClassColor, classes]"
    v-html="parsedSvg"
  />
</template>

<script setup>
import { computed } from 'vue'
import { useColorPalette } from '../composables/colorPalette'

const props = defineProps({
  svg: {
    type: [String, Object],
    required: true,
  },
  color: {
    type: String,
    default: '',
  },
  classes: {
    type: String,
    default: '',
  },
})

const { textColorClass } = useColorPalette()

const iconClassColor = computed(() => {
  // Don't add a text color class if it's already set in the parent
  return props.classes?.includes('text-')
    ? ''
    : textColorClass(props.color, null, 'text-darker')
})
const svgFromProp = computed(() => {
  // handle new icon selector plugin as well as legacy field
  // new field takes precedence over legacy field
  if (props.svg.selectedIcon) {
    return props.svg.selectedIcon.value
  }
  if (typeof props.svg === 'string') {
    return props.svg
  }
  return null
})
const parsedSvg = computed(() => {
  if (svgFromProp.value) {
    return (
      svgFromProp.value
        // Replace all fill and stroke attribute values by 'currentColor', except when the value is 'none'
        .replace(/fill="((?!none).)*?"/g, 'fill="currentColor"')
        .replace(/stroke="((?!none).)*?"/g, 'stroke="currentColor"')
        // Add attributes to the svg element
        .replace(
          /<svg ?(.*?)>/,
          `<svg $1 fill="currentColor" class="${
            props.classes || ''
          }" aria-hidden="true" alt="">`,
        )
    )
  }
  return ''
})
</script>
